import React from 'react'
import { Box, IconButton } from '@mui/material'
import { ArrowRightIcon, SparklesIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { Button } from '../../../../interaxDesignSystemComponents'
import { TESTIDS } from '../../../../config/testids'
import { useUser } from '../../../../hooks/useUser'
import { PlatformTourEntry, isPlatformTourAvailable, resolvePlatformTourEntry } from '../platformTourStops'
import { usePlatformTourControls } from '../hooks/usePlatformTourControls'
import { tourEntryDismissSx, tourEntryLabelSx, tourEntrySx } from './platformTourStyles'

/** The onboarding page header's way into the tour: "Take the tour" until it is done, "Resume tour" after a pause. */
export const PlatformTourEntryButton: React.FC = () => {
  const { t } = useTranslation()
  const { data: user } = useUser()
  const controls = usePlatformTourControls()
  const entry = resolvePlatformTourEntry(controls.tour, user?.tasks?.platformTour?.outcome)

  if (!isPlatformTourAvailable(user) || entry === PlatformTourEntry.NONE) return null

  const isResume = entry === PlatformTourEntry.RESUME
  const resumeEntry = {
    labelKey: 'gamer.platformTour.tourPaused',
    buttonKey: 'gamer.platformTour.resumeTour',
    onClick: controls.resume
  }
  const offerEntry = {
    labelKey: 'gamer.platformTour.newHere',
    buttonKey: 'gamer.platformTour.takeTheTour',
    onClick: controls.showWelcome
  }
  const shownEntry = isResume ? resumeEntry : offerEntry

  return (
    <Box sx={tourEntrySx}>
      <Box sx={tourEntryLabelSx}>
        <SparklesIcon aria-hidden />
        {t(shownEntry.labelKey)}
      </Box>

      <Button
        variant="primary"
        size="small"
        icon={<ArrowRightIcon className="w-4 h-4" />}
        iconPosition="right"
        onClick={shownEntry.onClick}
        data-testid={TESTIDS.PLATFORM_TOUR_ENTRY_BTN}
      >
        {t(shownEntry.buttonKey)}
      </Button>

      {isResume && (
        <IconButton
          onClick={controls.skip}
          aria-label={t('gamer.platformTour.dismissPausedTour')}
          sx={tourEntryDismissSx}
          data-testid={TESTIDS.PLATFORM_TOUR_ENTRY_DISMISS_BTN}
        >
          <XMarkIcon />
        </IconButton>
      )}
    </Box>
  )
}
